import { findRoom, isBackdrop } from './editing'
import { newButton, onMenuPage, pageLabel } from './pages'
import { pageIds, type LayoutDocument, type LayoutElement } from './types'

const GAP = 24

/** Whether el covers something solid drawn on the same menu page. */
function clashes(el: LayoutElement, doc: LayoutDocument, page: string): boolean {
  return doc.elements.some(
    (o) =>
      o.id !== el.id &&
      !isBackdrop(o.kind) &&
      onMenuPage(o, page) &&
      o.x < el.x + el.w &&
      el.x < o.x + o.w &&
      o.y < el.y + el.h &&
      el.y < o.y + o.h,
  )
}

/**
 * A button on the menu that opens a page nothing opens yet — the fix the
 * "nothing opens this page" warning offers. Placed after the menu's buttons or in
 * free room; when the service grid fills the menu, the grid gives up room at its
 * foot and the button goes under it. Named after the page in every language.
 */
export function addOpener(doc: LayoutDocument, pageId: string): { doc: LayoutDocument; buttonId: string } {
  const menu = pageIds(doc)[0]!
  const button = newButton(doc, menu, { kind: 'page', pageId })
  button.content = { az: pageLabel(doc, pageId, 'az'), en: pageLabel(doc, pageId, 'en'), ru: pageLabel(doc, pageId, 'ru') }
  let placed = findRoom(button, doc)
  let elements = doc.elements
  const grid = doc.elements.find((el) => el.kind === 'services' && onMenuPage(el, menu))
  if (clashes(placed, doc, menu) && grid && grid.h - button.h - GAP >= grid.h / 2) {
    const h = Math.min(button.h, 160)
    const shrunk = { ...grid, h: grid.h - h - GAP }
    placed = { ...button, x: grid.x, y: shrunk.y + shrunk.h + GAP, w: Math.min(button.w, grid.w), h }
    elements = doc.elements.map((el) => (el.id === grid.id ? shrunk : el))
  }
  return { doc: { ...doc, elements: [...elements, placed] }, buttonId: placed.id }
}
